import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  MonthlyGallonsData,
  PerTruckData,
  VendorBreakdownData,
  StateBreakdownData,
  YardVsRoadData,
} from '../interfaces';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  constructor(private api: ApiService) {}

  getMonthlyGallons(year?: number): Observable<MonthlyGallonsData[]> {
    const qs = year ? `?year=${year}` : '';
    return this.api.get<MonthlyGallonsData[]>(`/api/analytics/monthly-gallons${qs}`);
  }

  getPerTruck(year?: number, month?: number): Observable<PerTruckData[]> {
    const params: string[] = [];
    if (year != null) params.push(`year=${year}`);
    if (month != null) params.push(`month=${month}`);
    const qs = params.length ? `?${params.join('&')}` : '';
    return this.api.get<PerTruckData[]>(`/api/analytics/per-truck${qs}`);
  }

  getVendorBreakdown(year?: number, month?: number): Observable<VendorBreakdownData[]> {
    const params: string[] = [];
    if (year != null) params.push(`year=${year}`);
    if (month != null) params.push(`month=${month}`);
    const qs = params.length ? `?${params.join('&')}` : '';
    return this.api.get<VendorBreakdownData[]>(`/api/analytics/vendor-breakdown${qs}`);
  }

  getStateBreakdown(year?: number, month?: number): Observable<StateBreakdownData[]> {
    const params: string[] = [];
    if (year != null) params.push(`year=${year}`);
    if (month != null) params.push(`month=${month}`);
    const qs = params.length ? `?${params.join('&')}` : '';
    return this.api.get<StateBreakdownData[]>(`/api/analytics/state-breakdown${qs}`);
  }

  getYardVsRoad(year?: number, month?: number): Observable<YardVsRoadData[]> {
    const params: string[] = [];
    if (year != null) params.push(`year=${year}`);
    if (month != null) params.push(`month=${month}`);
    const qs = params.length ? `?${params.join('&')}` : '';
    return this.api.get<YardVsRoadData[]>(`/api/analytics/yard-vs-road${qs}`);
  }

}
